export default __webpack_public_path__ + "static/media/Gloves of the Still Pond.0637f9a6.jpg";